import Carousel from '@carvana/ds-carousel';

type OwnProps = React.PropsWithChildren<{
  hasBottomBorder?: boolean;
  headerTitle: string;
}>;

export default function VehicleCarousel({
  children,
  hasBottomBorder = false,
  headerTitle
}: OwnProps) {
  return (
    <div className="lg:px-4xl xl:max-w-[1352px]">
      <Carousel
        classes={{
          slide:
            'pl-xl first:pl-2xl last:pr-2xl sm:pl-2xl sm:first:pl-4xl sm:last:pr-4xl md:first:pl-3xl md:last:pr-3xl lg:pl-0 lg:first:pl-0 lg:last:pr-0 pb-[2px]',
          slides: 'gap-0 lg:gap-2xl',
          topSection:
            'px-2xl sm:px-4xl md:px-3xl gap-0 lg:px-0 sm:grid-cols-[1fr_auto]',
          pagination: 'sm:block',
          wrapper: 'sm:gap-3xl'
        }}
        ariaLabel="features you'll love"
        data-testid={`${headerTitle}-carousel`}
        headerContent={
          <div className="text-text-strong t-heading-lg sm:mb-sm md:t-heading-xl">
            {headerTitle}
          </div>
        }
        hideScrollBar
        slideByVisible
      >
        {children}
      </Carousel>
      {hasBottomBorder && (
        <div className="m-2xl border-b border-b-border-subtle sm:mx-4xl sm:my-3xl md:mx-3xl lg:mx-0" />
      )}
    </div>
  );
}
